/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {expire} from '../api'

export const useMutationExpire = createReactQueryMutationHook('expire', expire)
